// extracted by mini-css-extract-plugin
module.exports = {"controls-tablet-cell":"dece2e673c--controls-tablet-cell--Hdx5o"};